import React from "react";
import {Modal} from "antd";
import {useModel} from "../../../models";
import PssDetailList from "./PssDetailList";
import {OrderedListOutlined} from "@ant-design/icons";

const Title = () => {
    return (
        <h3 style={{flex: "1"}}>
            <OrderedListOutlined/>
            <span className="margin-left-8">进销存明细</span>
            <span className="margin-left-16">物料编码-CGHD12065656</span>
        </h3>
    )
}
export default function () {
    const [{pssVisible}, {setPssVisible}] = useModel("stockStatistic")
    const onClose = () => {
        setPssVisible(false);
    }
    const onOk = () => {
        setPssVisible(false);
    }
    return (
        <Modal
            title={<Title/>}
            width={1366}
            height={600}
            visible={pssVisible}
            footer={null}
            onOk={onOk}
            onCancel={onClose}
        >
            <PssDetailList/>
        </Modal>
    );
}